import numeri_associati_nomi_mario_response from '../assets/mock/numeri-caldi-nomi/numeri-caldi-nomi-mario.json'
import numeri_associati_nomi_franco_response from '../assets/mock/numeri-caldi-nomi/numeri-caldi-nomi-franco.json'
import numeri_associati_nomi_voidResponse from '../assets/mock/numeri-caldi-nomi/numeri-caldi-nome-void.json'

import numeri_fortunati_sogni_0_quests from '../assets/mock/test-psicolottico/test0/numeri-fortunati-sogni-test0-quests.json'
import numeri_fortunati_sogni_0_response from '../assets/mock/test-psicolottico/test0/numeri-fortunati-sogni-test0-response.json'
import numeri_fortunati_sogni_1_quests from '../assets/mock/test-psicolottico/test1/numeri-fortunati-sogni-test1-quests.json'
import numeri_fortunati_sogni_1_response from '../assets/mock/test-psicolottico/test1/numeri-fortunati-sogni-test1-response.json'
import numeri_fortunati_sogni_2_quests from '../assets/mock/test-psicolottico/test2/numeri-fortunati-sogni-test2-quests.json'
import numeri_fortunati_sogni_2_response from '../assets/mock/test-psicolottico/test2/numeri-fortunati-sogni-test2-response.json'

import numeri_caldi_amore from '../assets/mock/numeri-caldi-amore/numeri-caldi-amore.json'

import numeri_vincenti_cucina_step_1 from '../assets/mock/numeri-vincenti-cucina/step1/numeri-vincenti-cucina-step1-altro.json'
import numeri_vincenti_cucina_step_2 from '../assets/mock/numeri-vincenti-cucina/step2/numeri-vincenti-cucina-step2-acciughe.json'
import numeri_vincenti_cucina_step_3 from '../assets/mock/numeri-vincenti-cucina/step3/numeri-vincenti-cucina-step3.json'
import numeri_vincenti_cucina_response from '../assets/mock/numeri-vincenti-cucina/numeri-vincenti-cucina-response.json'

import numeri_fortunati_oroscopo_toro from '../assets/mock/numeri-fortunati-oroscopo/numeri-fortunati-oroscopo-toro.json'
import numeri_fortunati_oroscopo_ariete from '../assets/mock/numeri-fortunati-oroscopo/numeri-fortunati-oroscopo-ariete.json'
import numeri_fortunati_oroscopo_vergine from '../assets/mock/numeri-fortunati-oroscopo/numeri-fortunati-oroscopo-vergine.json'

import {
  CucinaResponseJSON,
  NomiNumeriResponseJSON,
  OroscopoResponseJSON,
  PsicolotticoResponseJSON
} from '../types/output-data'
import { TEST_PSICOLOTTICO } from '../types/enums'
import { CucinaRequestJSON } from '../types/input-data'

/* Funzioni ausiliarie che riportano i JSON mockati*/

// NOME
export const fetchMockedNomiResponseJSON = async (
  name: string
): Promise<NomiNumeriResponseJSON> => {
  switch (name.toLowerCase()) {
    case 'mario':
      return numeri_associati_nomi_mario_response
    case 'franco':
      return numeri_associati_nomi_franco_response
    default:
      return numeri_associati_nomi_voidResponse
  }
}

// TEST-PSICOLOTTICO
export const fetchQuestsForSelectedTest = (selectedTest: number) => {
  let questsJson = null
  switch (selectedTest) {
    case 0:
      questsJson = numeri_fortunati_sogni_0_quests
      break
    case 1:
      questsJson = numeri_fortunati_sogni_1_quests
      break
    case 2:
      questsJson = numeri_fortunati_sogni_2_quests
      break
    default:
      console.log('No valid test selected. Cannot retrieve quests for test psicolottico')
  }
  return questsJson
}

export const fetchMockedPsicolotticoResponseJSON = async (
  selectedTest: TEST_PSICOLOTTICO
): Promise<PsicolotticoResponseJSON> => {
  let responseJson = null
  switch (selectedTest) {
    case TEST_PSICOLOTTICO.LupoAgnello:
      responseJson = numeri_fortunati_sogni_0_response
      break
    case TEST_PSICOLOTTICO.GodersiVita:
      responseJson = numeri_fortunati_sogni_1_response
      break
    case TEST_PSICOLOTTICO.PaperoneGastone:
      responseJson = numeri_fortunati_sogni_2_response
      break
    default:
      console.log('No test selected. Cannot retrieve quests for test psicolottico')
  }
  return responseJson as PsicolotticoResponseJSON
}

// AMORE
export const fetchMockedAmoreResponseJSON = async () => {
  return numeri_caldi_amore
}

// CUCINA
export const fetchMockedCucinaOptionsForStep = async (
  currentStep: number
): Promise<CucinaRequestJSON> => {
  switch (currentStep) {
    case 1:
      return numeri_vincenti_cucina_step_1
    case 2:
      return numeri_vincenti_cucina_step_2
    case 3:
      return numeri_vincenti_cucina_step_3
    default:
      console.log('Invalid step. Cannot retrieve step response JSON for numeri vincenti cucina')
      return {
        course: '',
        firstIngredient: '',
        secondIngredient: '',
        recipe: ''
      }
  }
}

export const fetchMockedCucinaRicettaResponseJSON = async (): Promise<CucinaResponseJSON> => {
  return numeri_vincenti_cucina_response
}

export const fetchMockedOroscopoResponseJSON = async (
  starSign: string
): Promise<OroscopoResponseJSON> => {
  switch (starSign) {
    case 'Ariete':
      return numeri_fortunati_oroscopo_ariete
    case 'Toro':
      return numeri_fortunati_oroscopo_toro
    case 'Vergine':
    default:
      return numeri_fortunati_oroscopo_vergine
  }
}
